import { useState, useEffect } from "react";
import styled from "@emotion/styled";

import { Grid, Button, Card, CardHeader, CardContent, Checkbox, TextField, CardActions } from "@mui/material";

import PaidRoundedIcon from '@mui/icons-material/PaidRounded';

import { BasicFlex } from "../../../utils/Common";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { RowLine, HeaderRowLine, RowField, CheckField, AmountField } from "../../../utils/utilities/SelectableTableFields";

import { formatCurrency, formatGenericDate } from "../../../utils/util";

import { getAvailablePaymentsByCustomer, applyPaymentsToInvoice } from "../../Payments/apiService";

import { usePageData } from "../../../contexts/PageData";

import useSnackbarStore from "../../../store/snackbar";

const AvailablePayments = ({payment = {}}) => {

  const [available_payments, setAvailablePayments] = useState([]);

  const { data = {} } = usePageData();

  let balance = data.balance || 0;

  const queryClient = useQueryClient();

  const showSnackbar = useSnackbarStore(state => state.showSnackbar);

  const { data: payments } = useQuery({
    queryKey: ['payments', "available", data.customer_id],
    queryFn: () => getAvailablePaymentsByCustomer(data.customer_id),
    enabled: !!data.balance > 0 && !!data.customer_id
  });

  useEffect(() => {
    if(payments?.length) {
      setAvailablePayments(payments.map(payment => ({...payment, selected: false})));
    }
  }, [payments]);

  const handleChangeAmount = (e, index) => {
    let applied_amount = +e.target.value;

    setAvailablePayments(apv => {
      const newAppliedPayments = [...apv.map(el => ({ ...el }))];
      let payment = newAppliedPayments[index];
      let remaining_amount = balance - (newAppliedPayments.slice(0, index).filter(el => el?.selected).reduce((a, b) => a + b?.applied_amount, 0) || 0);
      console.log(applied_amount, payment.available_amount, remaining_amount, "!!!!!!!!!!!!!!!!!");
      applied_amount = applied_amount === "" ? "" : Math.min(applied_amount, payment.available_amount, remaining_amount);
      console.log(applied_amount, "applied_amount");
      newAppliedPayments[index] = { ...newAppliedPayments[index], applied_amount, selected: true };
      return newAppliedPayments;
    });
  }

  const handleChangeSelect = (e, index) => {
    if (balance <= 0) return;
    let remaining_amount = balance - (available_payments.slice(0, index).filter(el => el?.selected).reduce((a, b) => a + b?.applied_amount, 0) || 0);
    if (remaining_amount <= 0) return;
    let checked = e.target.checked;
    let payment = available_payments[index];
    let amount = Math.min(payment.available_amount, remaining_amount);
    const newAppliedPayments = [...available_payments];
    newAppliedPayments[index] = { ...newAppliedPayments[index], selected: checked, applied_amount: checked ? amount : "" };
    setAvailablePayments(newAppliedPayments);
  }

  console.log(available_payments, "available_payments");

  const { mutate: applyPayments } = useMutation({
    mutationFn: () => applyPaymentsToInvoice({invoice_id: data.invoice_id, available_payments}),
    onSuccess: () => {
      showSnackbar('Applied successfully!', 'success');
      queryClient.invalidateQueries({ queryKey: ['payments'] });
      queryClient.invalidateQueries({ queryKey: ['invoices'] });
    },
    onError: (e) => {
      console.log(e);
      showSnackbar('Failed to apply payments!', 'error');
    }
  })

  return (
    <Card variant="outlined">
      <CardHeader title="List of Available Payments" />
      <CardContent>
        <BasicFlex dir="column" my="1rem">
          <HeaderRowLine>
            <CheckField><Checkbox size="small" checkedIcon={<PaidRoundedIcon />} /></CheckField>
            <RowField $justify="flex-start">Payment #</RowField>
            <RowField $justify="flex-start">Date</RowField>
            <RowField $justify="flex-start">Method</RowField>
            <RowField $justify="flex-start">Info</RowField>
            <RowField $justify="flex-end">Amount</RowField>
            <RowField $justify="flex-end">Amount Available</RowField>
            <AmountField $justify="flex-end">Applied</AmountField>
          </HeaderRowLine>
          {!!data.balance > 0 && available_payments?.map((payment, i) => (
            <RowLine key={payment.invoice_id}>
              <CheckField><Checkbox size="small" checked={!!payment.selected} checkedIcon={<PaidRoundedIcon />} 
              onChange={(e) => handleChangeSelect(e, i)} 
              /></CheckField>
              <RowField $justify="flex-start">#{payment.payment_id}</RowField>
              <RowField $justify="flex-start">{formatGenericDate(payment.date, "short")}</RowField>
              <RowField $justify="flex-start">{payment.method}</RowField>
              <RowField $justify="flex-start">{payment.info}</RowField>
              <RowField $justify="flex-end">{formatCurrency(payment.amount)}</RowField>
              <RowField $justify="flex-end">{formatCurrency(payment.available_amount)}</RowField>
              <AmountField $justify="flex-end"><TextField size="small" type="number" value={payment.applied_amount} 
              onChange={(e) => handleChangeAmount(e, i)} 
              slotProps={{ input: {style: {backgroundColor: "white"}} }} /></AmountField>
            </RowLine>
          ))}
        </BasicFlex> 
      </CardContent>

      <CardActions sx={{justifyContent: "flex-end", p: 2}}>
        {/* <Button size="small" variant="outlined">Cancel</Button> */}
        <Button variant="contained" onClick={applyPayments} disabled={!available_payments.filter(el => el?.selected).length}>Apply Payments</Button>
      </CardActions>

    </Card>
  )

};

export default AvailablePayments;